module.exports = __webpack_public_path__ + "static/img/gotop.2734364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gotop.png
// module id = JHCM
// module chunks = 1